export const OCP_PROJECT_TYPE = 'OpenCollaborationPlatform';
